import { Injectable } from '@angular/core';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  Page,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomBasePageMetaResolver } from './custom-base-page-meta.resolver';

@Injectable({
  providedIn: 'root',
})
export class CustomContentPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  constructor(private basePageMetaResolver: CustomBasePageMetaResolver) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
  }

  resolveTitle(): Observable<string> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }

  /**
   * Если тип страницы отличается от стандартных, то страница
   * не получает метарезолвер. Чтобы избежать этого поведения,
   * мы переопределили метод getScore у контентной страницы.
   * Мы подстраховались и возвращаем значение 0.5. Это значит,
   * что этот метарезолвер не перебьет по специфичности другие
   * метарезолверы у которых может быть значение 1.
   */
  getScore(page: Page): number {
    return this.isStandardType(page) ? super.getScore(page) : 0.5;
  }

  isStandardType(page: Page): boolean {
    return page.type ? (Object.values(PageType) as string[]).includes(page.type) : false;
  }
}
